export enum CoursePlanStatusDTO {
    Active = "Active",
    Inactive = "Inactive",
    Deleted = "Deleted"
}
